import React from 'react';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import MapIcon from '../../assets/images/map-pin-icon-google.svg';

const LocationsMap = withGoogleMap(props => {

  const { contents, onShowContent } = props;

  const markers = contents.reduce((mapItems, content, index) => {

    if (content.latitude && content.longitude) {
      const handleShowContent = () => onShowContent(content);
      const position = new window.google.maps.LatLng(content.latitude, content.longitude);

      mapItems.push((
        <Marker
          key={content.id}
          position={position}
          onClick={handleShowContent}
          title="Click Me"
          icon={MapIcon}
        />
      ));
    }

    return mapItems;
  }, []);

  let defaultCenter = props.zoom == 17 ? { lat: contents[0].latitude, lng: contents[0].longitude } : null;
  if (props.center) {
    defaultCenter = { lat: props.center.latitude, lng: props.center.longitude };
  }
  const options = { scrollwheel: true, streetViewControl: true, zoomControl: true };
  const zoom = 12;
  return (
    <GoogleMap
      ref={props.onMapMounted}
      options={options}
      defaultOptions={options}
      center={defaultCenter}
      defaultZoom={zoom}
      zoom={props.zoom ? props.zoom : zoom}
    >
    {markers}
    </GoogleMap>
  );
});
  
export default LocationsMap;



// WEBPACK FOOTER //
// ./src/components/LocationsMap/index.js